const EN_MESSAGES = {
  'required.oneweek': 'At least one week is required.',
  'required.tshirt': 'T-Shirt size is required.',
  'required.childFullName': "Child's full name is required.",
  'required.childDob': "Child's date of birth is required.",
  'required.childAge': "Child's age is required.",
  'required.childGender': "Child's gender is required.",
  'required.parentName': "Parent/guardian's full name is required.",
  'required.parentRelationship': "Parent/guardian's relationship to the child is required.",
  'required.parentPhone': "Parent/guardian's phone number is required.",
  'required.parentEmail': "Parent/guardian's email is required.",
  'required.parentAddress': "Parent/guardian's full address is required.",
  'required.emergencyName': "Emergency contact's full name is required.",
  'required.emergencyRelationship': "Emergency contact's relationship is required.",
  'required.emergencyPhone': "Emergency contact's phone number is required.",
  'required.language': "At least one language is required.",
  'required.allergyInfo': "Allergy information is required.",
  'required.allergySpecify': "Specifying the allergies is required.",
  'required.medicationInfo': "Medication information is required.",
  'required.medicationSpecify': "Specifying the medication is required.",
  'required.terms': "Accepting all terms and conditions is required.",
  'price.camp': (n: number) => `${n} week${n > 1 ? 's' : ''} of camp`,
  'price.morningCare': 'Morning care',
  'price.eveningCare': 'Evening care',
  'price.tshirt': 'Camp T-Shirt',
  'button.processing': 'Processing',
};

const FR_MESSAGES: typeof EN_MESSAGES = {
  'required.oneweek': 'Au moins une semaine est requise.',
  'required.tshirt': 'La taille du t-shirt est requise.',
  'required.childFullName': "Le nom complet de l'enfant est requis.",
  'required.childDob': "La date de naissance de l'enfant est requise.",
  'required.childAge': "L'âge de l'enfant est requis.",
  'required.childGender': "Le sexe de l'enfant est requis.",
  'required.parentName': "Le nom complet du parent/tuteur est requis.",
  'required.parentRelationship': "Le lien de parenté avec l'enfant est requis.",
  'required.parentPhone': "Le numéro de téléphone du parent/tuteur est requis.",
  'required.parentEmail': "L'adresse courriel du parent/tuteur est requise.",
  'required.parentAddress': "L'adresse complète du parent/tuteur est requise.",
  'required.emergencyName': "Le nom complet du contact d'urgence est requis.",
  'required.emergencyRelationship': "Le lien de parenté du contact d'urgence est requis.",
  'required.emergencyPhone': "Le numéro de téléphone du contact d'urgence est requis.",
  'required.language': "Au moins une langue est requise.",
  'required.allergyInfo': "Les renseignements sur les allergies sont requis.",
  'required.allergySpecify': "Veuillez préciser les allergies.",
  'required.medicationInfo': "Les renseignements sur les médicaments sont requis.",
  'required.medicationSpecify': "Veuillez préciser les médicaments.",
  'required.terms': "Vous devez accepter tous les termes et conditions.",
  'price.camp': (n: number) => `${n} semaine${n > 1 ? 's' : ''} de camp`,
  'price.morningCare': 'Service de garde (matin)',
  'price.eveningCare': 'Service de garde (soir)',
  'price.tshirt': 'Camp T-Shirt',
  'button.processing': 'Chargement',
};

export type MessageKey = keyof typeof EN_MESSAGES;

const LANGUAGE_MAP = document.documentElement.lang === 'fr' ? FR_MESSAGES : EN_MESSAGES;

export function getMessage<K extends MessageKey>(key: K): typeof EN_MESSAGES[K] {
  return LANGUAGE_MAP[key];
}